/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Analytics Reports API
 * API для генерации PDF/XLSX отчетов по аналитике медицинских клиник.

Все отчеты генерируются асинхронно в фоновом режиме. 
После создания задачи вы получаете `jobId` (UUID), по которому можно отслеживать статус и скачать готовый файл.

**Типы отчетов:**
- Общие показатели
- KPI по записям
- Подтверждение записи
- Отмена записи
- Статистика по виджету
- Статистика по отзывам
- Статистика по источникам записей

 * OpenAPI spec version: 1.0.0
 */

import type { RequestHandlerOptions } from "msw"
import { delay, HttpResponse, http } from "msw"

import type { JobCreatedResponse } from ".././types"

export const getGenerateGeneralAppointmentsReportResponseMock = (
	overrideResponse: Partial<Extract<JobCreatedResponse, object>> = {},
): JobCreatedResponse => ({
	jobId: "550e8400-e29b-41d4-a716-446655440000",
	status: "pending",
	reportType: "general_appointments",
	name: "general-appointments-2025-01-15",
	format: "pdf",
	extension: "pdf",
	createdAt: "2025-01-15T10:30:00Z",
	estimatedCompletionTime: 120,
	...overrideResponse,
})

export const getGenerateWidgetStatisticsReportResponseMock = (
	overrideResponse: Partial<Extract<JobCreatedResponse, object>> = {},
): JobCreatedResponse => ({
	jobId: "550e8400-e29b-41d4-a716-446655440000",
	status: "pending",
	reportType: "general_appointments",
	name: "general-appointments-2025-01-15",
	format: "pdf",
	extension: "pdf",
	createdAt: "2025-01-15T10:30:00Z",
	estimatedCompletionTime: 120,
	...overrideResponse,
})

export const getGenerateReviewsStatisticsReportResponseMock = (
	overrideResponse: Partial<Extract<JobCreatedResponse, object>> = {},
): JobCreatedResponse => ({
	jobId: "550e8400-e29b-41d4-a716-446655440000",
	status: "pending",
	reportType: "general_appointments",
	name: "general-appointments-2025-01-15",
	format: "pdf",
	extension: "pdf",
	createdAt: "2025-01-15T10:30:00Z",
	estimatedCompletionTime: 120,
	...overrideResponse,
})

export const getGenerateBookingSourcesReportResponseMock = (
	overrideResponse: Partial<Extract<JobCreatedResponse, object>> = {},
): JobCreatedResponse => ({
	jobId: "550e8400-e29b-41d4-a716-446655440000",
	status: "pending",
	reportType: "general_appointments",
	name: "general-appointments-2025-01-15",
	format: "pdf",
	extension: "pdf",
	createdAt: "2025-01-15T10:30:00Z",
	estimatedCompletionTime: 120,
	...overrideResponse,
})

export const getGenerateAppointmentConfirmationReportResponseMock = (
	overrideResponse: Partial<Extract<JobCreatedResponse, object>> = {},
): JobCreatedResponse => ({
	jobId: "550e8400-e29b-41d4-a716-446655440000",
	status: "pending",
	reportType: "general_appointments",
	name: "general-appointments-2025-01-15",
	format: "pdf",
	extension: "pdf",
	createdAt: "2025-01-15T10:30:00Z",
	estimatedCompletionTime: 120,
	...overrideResponse,
})

export const getGenerateGeneralAppointmentsReportMockHandler = (
	overrideResponse?:
		| JobCreatedResponse
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<JobCreatedResponse> | JobCreatedResponse),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/reports/generate/general-appointments",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGenerateGeneralAppointmentsReportResponseMock(),
				{ status: 202 },
			)
		},
		options,
	)
}

export const getGenerateWidgetStatisticsReportMockHandler = (
	overrideResponse?:
		| JobCreatedResponse
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<JobCreatedResponse> | JobCreatedResponse),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/reports/generate/widget-statistics",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGenerateWidgetStatisticsReportResponseMock(),
				{ status: 202 },
			)
		},
		options,
	)
}

export const getGenerateReviewsStatisticsReportMockHandler = (
	overrideResponse?:
		| JobCreatedResponse
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<JobCreatedResponse> | JobCreatedResponse),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/reports/generate/reviews-statistics",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGenerateReviewsStatisticsReportResponseMock(),
				{ status: 202 },
			)
		},
		options,
	)
}

export const getGenerateBookingSourcesReportMockHandler = (
	overrideResponse?:
		| JobCreatedResponse
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<JobCreatedResponse> | JobCreatedResponse),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/reports/generate/booking-sources",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGenerateBookingSourcesReportResponseMock(),
				{ status: 202 },
			)
		},
		options,
	)
}

export const getGenerateAppointmentConfirmationReportMockHandler = (
	overrideResponse?:
		| JobCreatedResponse
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<JobCreatedResponse> | JobCreatedResponse),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/reports/generate/appointment-confirmation",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGenerateAppointmentConfirmationReportResponseMock(),
				{ status: 202 },
			)
		},
		options,
	)
}
export const getReportsMock = () => [
	getGenerateGeneralAppointmentsReportMockHandler(),
	getGenerateWidgetStatisticsReportMockHandler(),
	getGenerateReviewsStatisticsReportMockHandler(),
	getGenerateBookingSourcesReportMockHandler(),
	getGenerateAppointmentConfirmationReportMockHandler(),
]
